@if (customWarning?.shouldRender) {
  <span class="custom-warning">
    {{ customWarning?.message }}
  </span>
}
